import { useCallback, useState } from 'react'
import { NoneToVoidFunction } from './types'

const useFlag = (
  initial = false,
): [boolean, NoneToVoidFunction, NoneToVoidFunction, NoneToVoidFunction] => {
  const [value, setValue] = useState(initial)

  const setTrue = useCallback(() => {
    setValue(true)
  }, [])

  const setFalse = useCallback(() => {
    setValue(false)
  }, [])

  const toggle = useCallback(() => {
    setValue(value => !value)
  }, [])

  return [value, setTrue, setFalse, toggle]
}

export default useFlag
